import type { AdaptiveVocabularySize } from '../utils/adaptiveModels';

const VOCAB_RESULT_DATA_KEY = 'vocabResultData';

export interface UnknownWord {
  headword: string;
  definition: string;
  // Question tags the word was asked with, e.g. "idiom". Absent from results saved
  // before the tags were kept.
  tags?: string[];
}

export interface VocabResultData {
  shortcode: string;
  vocabSize: AdaptiveVocabularySize;
  unknownWords: UnknownWord[];
  userEmail: string | undefined;
}

export function saveVocabResultData(data: VocabResultData): void {
  localStorage.setItem(VOCAB_RESULT_DATA_KEY, JSON.stringify(data));
}

export function getVocabResultData(): VocabResultData | null {
  const raw = localStorage.getItem(VOCAB_RESULT_DATA_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as VocabResultData;
  } catch {
    return null;
  }
}

export function clearVocabResultData(): void {
  localStorage.removeItem(VOCAB_RESULT_DATA_KEY);
}
